export function excludeUndefinedProps(o) {
	return Object.keys(o).reduce((result, key) => {
		if (o[key] !== undefined) {
			result[key] = o[key];
		}
		return result;
	}, {});
}

export function excludeProps<T>(o: T, ...keys: Array<keyof T>): Partial<T> {
	return Object.keys(o).reduce((result, key) => {
		if (!keys.includes(key as any)) {
			result[key] = o[key];
		}
		return result;
	}, {});
}
